import { MenuItemStyled } from '@molecules/Filters/styles';
import { SelectChangeEvent } from '@mui/material';
import { EStatusLinkManagement } from '@organisms/Tables/Enterprise/LinksManagementTable/enums';
import { getConfigStatusLinkManagement } from '@organisms/Tables/Enterprise/LinksManagementTable/utils';
import CustomSelect from '../CustomSelect/CustomSelect';
import { ICustomSelectProps } from '../types';
import React from 'react';

interface ILinkManagementStatusSelectProps extends ICustomSelectProps {}

const LinkManagementStatusSelect = ({
  savedDataSelectedRow,
  setSavedDataSelectedRow,
  handleClose,
  customSxForSelect,
  ...props
}: ILinkManagementStatusSelectProps) => {
  const handleOnChange = (event: SelectChangeEvent<unknown>) => {
    const value = event.target.value as EStatusLinkManagement;
    event.stopPropagation();
    setSavedDataSelectedRow({
      ...savedDataSelectedRow,
      status: Number(value),
    });
  };

  return (
    <CustomSelect
      title="Status:"
      listData={EStatusLinkManagement}
      handleOnChange={handleOnChange}
      handleClose={handleClose}
      customSxForSelect={customSxForSelect}
      {...props}
    >
      {Object.entries(EStatusLinkManagement).map(([, status]) => {
        const config = getConfigStatusLinkManagement(status as EStatusLinkManagement);
        return (
          <MenuItemStyled key={status} value={status} sx={{ color: config?.filterColor }}>
            {config?.status}
          </MenuItemStyled>
        );
      })}
    </CustomSelect>
  );
};

export default React.memo(LinkManagementStatusSelect);
